import { SVGProps } from "react";

const TransactionsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="current"
    stroke="current"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10.98 22.854a.77.77 0 0 1-.626-.312l-1.052-1.407c-.219-.291-.51-.458-.823-.479-.312-.02-.625.125-.875.386-1.51 1.614-2.656 1.479-3.208 1.27-.563-.218-1.51-.937-1.51-3.25V7.334c0-4.625 1.333-6.03 5.697-6.03h7.865c4.365 0 5.698 1.405 5.698 6.03v4.438a.787.787 0 0 1-.781.781.787.787 0 0 1-.782-.781V7.333c0-3.76-.656-4.468-4.135-4.468H8.583c-3.479 0-4.135.708-4.135 4.468v11.73c0 1.093.27 1.697.52 1.791.188.073.699-.031 1.49-.875.573-.604 1.323-.927 2.105-.885.77.041 1.5.448 1.99 1.104l1.062 1.406a.782.782 0 0 1-.636 1.25Z" />
    <path d="M18.958 23.073a4.117 4.117 0 0 1-4.114-4.115 4.117 4.117 0 0 1 4.114-4.114 4.117 4.117 0 0 1 4.115 4.114 4.117 4.117 0 0 1-4.115 4.115Zm0-6.667a2.556 2.556 0 0 0-2.552 2.552 2.556 2.556 0 0 0 2.552 2.552 2.556 2.556 0 0 0 2.552-2.552 2.556 2.556 0 0 0-2.552-2.552Z" />
    <path d="M22.917 23.698a.773.773 0 0 1-.553-.23l-1.041-1.04a.786.786 0 0 1 0-1.105.786.786 0 0 1 1.104 0l1.042 1.042a.786.786 0 0 1 0 1.104.773.773 0 0 1-.552.229ZM16.667 8.073H8.333a.787.787 0 0 1-.78-.781c0-.427.353-.782.78-.782h8.334c.427 0 .781.355.781.782a.787.787 0 0 1-.781.78ZM15.625 12.24h-6.25a.787.787 0 0 1-.781-.782c0-.427.354-.78.781-.78h6.25c.427 0 .781.353.781.78a.787.787 0 0 1-.781.782Z" />
  </svg>
);

export default TransactionsIcon;
